import React, { forwardRef } from 'react';
import { withRouter, Link, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Store from 'store';
import store from '../../store';
import images from '../../assets';

import {
  TopBar,
  TopBarList,
  TopBarItem,
  GnbExpoMenu,
  GnbExpoMenuVer2,
  GnbExpoMenuVer3,
  GnbExpoMenuVer4,
  GnbExpoMenuVer5,
  GnbExpoMenuVer6,
  GnbPrevMenu,
  GnbMenuItem,
  GnbMenuItemVer2,
  GnbMenuItemVer3,
  GnbMenuItemVer4,
  GnbMenuGroup,
  LanguageBtn,
  subMenuListGroup
} from './TopBar';
import { Vdivider, HorizontalSp, VerticalSp, MediaQuery, HSLine } from '../Common';
import { Button } from '@material-ui/core';
import { CartCountBadge } from '../badge/MyCartBadge'
import { StyledMenu, StyledMenuItem } from './SubMenu';
export const HeaderTablet = forwardRef((
  {
    t, 
    i18n, 
    sevmenu, 
    overbtn, 
    hideMenu, 
    onOpenMypageRightGnbMenu, 
    changeState, 
    onOpenBasketRightGnbMenu, 
    onOpenGnbMenu, 
    priceMenuRef, 
    guideMenuRef,
    profileMenuRef,
    mybasketRef
  }
  , ref) => {
  const history = useHistory();
  const totalCartCount = useSelector(state => state.getUserInfo.totalCartCount);
  const authdata = localStorage.getItem('userData');
  const onGoHome = async () => {
    hideMenu();
    history.push('/');
  };
  const onGoAIGenerateIntro = (e) => {
    hideMenu();
    history.push('/generate/intro/0');
  };

  const onGoAgentIntro = (e) => {
    hideMenu();
    history.push('/intro/agent');
  };

  const onGoTrends = (e) => {
    hideMenu();
    history.push('/trend');
  };

  const onBasket = (e) => {
    hideMenu();
    history.push('/mypage/purchase/basket');
  };

  const onGoAIGenerateBasket = (e) => {
    hideMenu();
    history.push('/mypage/generate/basket');
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    Store.set('lang', lng);
    window.location.reload();
  };

  const subMenuOnOf = (overbtn, action) => {
   if(overbtn === action){
    changeState(overbtn, '');
   }else if(overbtn === ''){
    changeState(overbtn, action);
   }else{

   }
  };

  const onGoLicenseGuide = (e) => {
    hideMenu();
    history.push('/guide');
  };

  const onGoAIGeneratePrice = (e) => {
    hideMenu();
    history.push('/generate/intro/1');
  };

  const onGoIntro = (e) => {
    hideMenu();
    history.push('/intro');
  }

  const onGoSellerGuide = (e) => {
    hideMenu();
    history.push('/guide/seller');
  };

  const onGoBuyerGuide = (e) => {
    hideMenu();
    history.push('/guide/buyer');
  };

  const onGoVipGuide = (e) => {
    hideMenu();
    history.push('/guide/vip');
  };

  const onGoFaqIntro = (e) => {
    hideMenu();
    history.push('/intro/faq');
  };

  const onGoAuth = () => {
    hideMenu();
    history.push('/auth');
  };

  const onMyPage = () => {
    hideMenu();
    history.push('/mypage');
  };

  const onPurchase = (e) => {
    hideMenu();
    history.push('/mypage/purchase');
  };

  const onSales = (e) => {
    hideMenu();
    history.push('/mypage/sales');
  };

  const onGoAIGenerateResult = (e) => {
    hideMenu();
    history.push('/mypage/generate/result');
  };

  const onReqSeller = (e) => {
    hideMenu();
    history.push('/mypage/basic/reqseller');
  };

  const onLogout = () => {
    localStorage.removeItem('authdata');
    localStorage.removeItem('userData');
    localStorage.removeItem('accessToken');
    window.location.href = '/';
  };

  return  (
    <>
      <Link to="#" onClick={onGoHome}>
        <img alt="" src={images.top_logo} style={{ marginLeft: 15, height: 30 }} />
      </Link>
        <TopBarList>
          {/* 디자인 */}
          <TopBarItem
            underline={'none'}
            onClick={() => {
              changeState('overbtn', overbtn === 'design' ? '' : 'design');
            }}
            ref={ref}
            active={overbtn === 'design'}
            title={t('header_menu_design')}
          />
          <Vdivider />
          {/*  AI디자인 제작 서비스. */}
          <TopBarItem
            underline={'none'}
            onClick={() => {
              changeState('ai_generate', overbtn === 'ai_generate' ? '' : 'ai_generate' );
              onGoAIGenerateIntro();
            }}
            extm={false}
            active={overbtn === 'ai_generate'}
            title={t('ai_generate3')}
          >
            { Store.get('lang') === 'kr' ?
              <div style={{position: 'absolute',
              display: 'flex',
              right: -2,
              top: -10,
              borderRadius: 100,
              backgroundColor: "#fe8b07",
              color: 'white',
              fontSize: 10,
              fontFamily: 'NSCJKrM',
              paddingLeft: 5,
              paddingRight: 5,
              paddingBottom: 2,
              margin: '0px 5px',
              lineHeight: '18px',}}>
              New</div>
              : 
              <div style={{
                position: 'absolute',
                display: 'flex',
                right: -5,
                top: -15,
                borderRadius: 100,
                backgroundColor: "#fe8b07",
                color: 'white',
                fontSize: 10,
                fontFamily: 'NSCJKrM',
                paddingLeft: 5,
                paddingRight: 5,
                paddingBottom: 2,
                margin: '0px 5px',
                lineHeight: '18px',}}>
                New</div>
                
              }
              
          </TopBarItem>
          <Vdivider />
          {/* 서비스  */}
          <TopBarItem
            underline={'none'}
            onClick={() => {
              changeState('service', overbtn === 'service' ? '' : 'service' );
            }}
            extm={false}
            onClick={onGoAgentIntro}
            active={overbtn === 'service'}
            title={t('header_menu_us_copyright2')}
          >
            { Store.get('lang') === 'kr' ?
              <div 
                style={{
                  position: 'absolute',
                  display: 'flex',
                  right: -2,
                  top: -10,
                  borderRadius: 100,
                  backgroundColor: "#fe8b07",
                  color: 'white',
                  fontSize: 10,
                  fontFamily: 'NSCJKrM',
                  paddingLeft: 5,
                  paddingRight: 5,
                  paddingBottom: 2,
                  margin: '0px 5px',
                  lineHeight: '18px',
                }}
              >
                New
              </div>
              : 
              <div style={{
                position: 'absolute',
                display: 'flex',
                right: -5,
                top: -15,
                borderRadius: 100,
                backgroundColor: "#fe8b07",
                color: 'white',
                fontSize: 10,
                fontFamily: 'NSCJKrM',
                paddingLeft: 5,
                paddingRight: 5,
                paddingBottom: 2,
                margin: '0px 5px',
                lineHeight: '18px',}}>
                New</div>
                
              }
          </TopBarItem>
          <Vdivider />

          <TopBarItem
            underline={'none'}
            onClick={() => {
              changeState('trende', overbtn === 'trende' ? '' : 'trende' );
            }}
            active={overbtn === 'trende'}
            title={t('trend')}
            extm={false}
            onClick={onGoTrends}
          />
        </TopBarList>
        <TopBarItem
          underline={'none'}
          onClick={() => {
            changeState('overbtn', overbtn === 'price' ? '' : 'price')
          }}
          active={overbtn === 'price'}
          title={t('price')}
          ref={priceMenuRef}
        >
          {overbtn === 'price' && (
            <StyledMenu
              onMouseLeave={() => {
                changeState('overbtn', '')
              }}
            >
              {/* 디자인 라이센스 */}
              <StyledMenuItem
                onClick={onGoLicenseGuide}
                onMouseEnter={() => {
                  changeState('sevmenu', 'dlicense')
                }}
                onMouseLeave={() => {
                  changeState('sevmenu', '')
                }}
                active={sevmenu === 'dlicense'}
                title={t('design_licensev2')}
              />
              {/* AI 제작 요금제  */}
              <StyledMenuItem
                onClick={onGoAIGeneratePrice}
                onMouseEnter={() => {
                  changeState('sevmenu', 'aiprice')
                }}
                onMouseLeave={() => {
                  changeState('sevmenu', '')
                }}
                active={sevmenu === 'aiprice'}
                title={t('ai_generate_pricev2')}
              />
            </StyledMenu>
          )}
        </TopBarItem>
        <Vdivider />

        {/* 가이드 */}
        <TopBarItem
          underline={'none'}
          onClick={() => {
            changeState('overbtn', overbtn === 'guide' ? '' : 'guide')
          }}
          active={overbtn === 'guide'}
          title={t('guide')}
          ref={guideMenuRef}
        >
          {overbtn === 'guide' && (
            <StyledMenu
              onMouseLeave={() => {
                changeState('overbtn', '');
              }}
              ref={guideMenuRef}
            >
              <StyledMenuItem
                onClick={onGoIntro}
                onMouseEnter={() => {
                  changeState('sevmenu', '');
                }}
                onMouseLeave={() => {
                  changeState('sevmenu', '');
                }}
                active={sevmenu === 'intro'}
                title={t('export_mediation_service')}
              />
              <StyledMenuItem
                onClick={onGoSellerGuide}
                onMouseEnter={() => {
                  changeState('sevmenu', '');
                }}
                onMouseLeave={() => {
                  changeState('sevmenu', 'aiprice');
                }}
                active={sevmenu === 'aiprice'}
                title={t('guide_for_sellers')}
              />
              <StyledMenuItem
                onClick={onGoBuyerGuide}
                onMouseEnter={() => {
                  changeState('sevmenu', '');
                }}
                onMouseLeave={() => {
                  changeState('sevmenu', '');
                }}

                active={sevmenu === 'intro'}
                title={t('guide_for_buyer')}
              />
              <StyledMenuItem
                onClick={onGoVipGuide}
                onMouseEnter={() => {
                  changeState('sevmenu', '');
                }}
                onMouseLeave={() => {
                  changeState('sevmenu', '');
                }}
                active={sevmenu === 'intro'}
                title={t('what_is_vip_seller')}
              />
              <HSLine bgcolor="#dddddd" />
              <StyledMenuItem
                onClick={onGoFaqIntro}
                onMouseEnter={() => {
                  changeState('sevmenu', '');
                }}
                onMouseLeave={() => {
                  changeState('sevmenu', '');
                }}
                active={sevmenu === 'intro'}
                title={t('faq')}
              />
            </StyledMenu>
          )}
        </TopBarItem>
      <div style={{display: 'flex',}}>
        {/* 로그인 버튼(로그인 전)  */}
        {authdata === null && (
          <Button size="small" style={{ minWidth: 40 }} onClick={onGoAuth}>
            <img alt="" src={images.topbar_login} style={{ width: 20, height: 20 }} />
          </Button>
        )}
        {/* 프로필 이미지 */}
        {authdata !== null && (
          <Button className="circle-wrapper"
            onClick={() => {
              changeState('overbtn', overbtn === 'myprofile' ? '' : 'myprofile')
            }} 
            size="small" style={{ minWidth: 40 }}
            ref = {profileMenuRef}
          >
            <div class="circle"></div>
            <img
              alt=""
              src={
                store.getState().profile_img
                  ? `${process.env.REACT_APP_S3_BUCKET_DOMAIN}${store.getState().profile_img}`
                  : images.topbar_avatar
              }
              style={{ width: 20, height: 20, borderRadius: 15 }}
            />
            {overbtn === 'myprofile' && (
            <StyledMenu
              onMouseLeave={() => {
                changeState('overbtn', '');
              }}
            >
              <StyledMenuItem
                onClick={onMyPage}
                onMouseEnter={() => {
                  changeState('sevmenu', '');
                }}
                onMouseLeave={() => {
                  changeState('sevmenu', '');
                }}
                active={sevmenu === 'my_profile'}
                title={t('my_profile')}
              />
              <StyledMenuItem
                onClick={onPurchase}
                onMouseEnter={() => {
                  changeState('sevmenu', '');
                }}
                onMouseLeave={() => {
                  changeState('sevmenu', '');
                }}
                active={sevmenu === 'transactions_buy'}
                title={t('transactions_buy')}
              />
            
            {store.getState().seller_account_status === 3 ?
              ( /* seller 계정으로 로그인 한 경우 */
                <StyledMenuItem
                  onClick={onSales}
                  onMouseEnter={() => {
                    changeState('sevmenu', '');
                  }}
                  onMouseLeave={() => {
                    changeState('sevmenu', '');
                  }}
                  active={sevmenu === 'product_management'}
                  title={t('product_management')}
                />)
              : null
              }
            <StyledMenuItem
                onClick={onGoAIGenerateResult}
                onMouseEnter={() => {
                  changeState('sevmenu', '');
                }}
                onMouseLeave={() => {
                  changeState('sevmenu', '');
                }}
                active={sevmenu === 'ai_generate_result'}
                title={t('ai_generate_result2')}
              />

              {store.getState().seller_account_status !== 3 ?
                (  /* buyer 계정으로 로그인 한 경우 */
                  <StyledMenuItem
                    onClick={onReqSeller}
                    onMouseEnter={() => {
                      changeState('sevmenu', '');
                    }}
                    onMouseLeave={() => {
                      changeState('sevmenu', '');
                    }}
                    active={sevmenu === 'apply_for_vip_seller_3'}
                    title={t('apply_for_vip_seller_3')}
                  />)
                : null
              }
              
              
              {/* 가로 선 만들기 */}
              <HSLine bgcolor="#dddddd" />


              {/* 로그아웃 버튼 달기 */}

              <StyledMenuItem
                onClick={onLogout}
                onMouseEnter={() => {
                  changeState('sevmenu', '');
                }}
                onMouseLeave={() => {
                  changeState('sevmenu', '');
                }}
                logout={true}
                active={sevmenu === 'sign_out'}
                title={t('sign_out')}
                
              />
            </StyledMenu>
          )}
          </Button>
        )}
        {/* 검색 버튼 */}
        <MediaQuery min={1320}>
          <Button size="small" style={{ minWidth: 40 }}  onClick={() => {
              changeState('overbtn', overbtn === 'search' ? '' : 'search')
            }}>
            <img alt="" src={images.topbar_search} style={{ width: 20, height: 20 }} />
          </Button>
        </MediaQuery>

        {/* 장바구니 */}
        {authdata !== null && (
          <div className="circle-wrapper"
            onClick={()=>{
              changeState('overbtn', overbtn === 'mybasket' ? '' : 'mybasket');
            }}
            active={overbtn === 'mybasket'}
            size="small"
            style={{ padding: 10 }}
            ref={mybasketRef}
          >
          <div style={{ display: "flex", justifyContent: "center", cursor: "pointer" }}>
            <MediaQuery min={1424}>
              <CartCountBadge count={totalCartCount} onClick={onOpenBasketRightGnbMenu}>
                <img alt="" src={images.topbar_basket} style={{ width: 26, height: 26 }} />
              </CartCountBadge>
            </MediaQuery>
            <MediaQuery max={1423}>
              <CartCountBadge count={totalCartCount} onClick={onOpenBasketRightGnbMenu}>
                <img alt="" src={images.topbar_basket} style={{ width: 20, height: 20 }} />
              </CartCountBadge>
            </MediaQuery>

            {overbtn === 'mybasket' && (
              <StyledMenu
                onMouseLeave={() => { changeState('overbtn', '' ) }}
              >
                <StyledMenuItem
                  onClick={onBasket}
                  onMouseEnter={() => { changeState('sevmenu', '' ) }}
                  onMouseLeave={() => { changeState('sevmenu', '' ) }}
                  active={sevmenu === 'shopping_cart'}
                  title={t('shopping_cart')}
                />
                <StyledMenuItem
                  onClick={onGoAIGenerateBasket}
                  onMouseEnter={() => { changeState('sevmenu', '' ) }}
                  onMouseLeave={() => { changeState('sevmenu', '' ) }}
                  active={sevmenu === 'ai_shopping_cart'}
                  title={t('ai_shopping_cart')}
                />
              </StyledMenu>
            )}
          </div>
        </div> 
        )}
        <div style={{ position: 'relative' }}>
          <LanguageBtn
            value={
              Store.get('lang')
                ? Store.get('lang')
                : navigator.language === 'ko-KR' || navigator.language === 'ko'
                  ? 'kr'
                  : 'en'
            }
            active={overbtn === 'lang'}
            onClick={()=>{
              changeState('overbtn', overbtn === 'lang' ? '' : 'lang');
            }}
            onChange={(val) => changeLanguage(val)}
          />
        </div>
      </div>
    </>
  );
});